import React, { SFC } from 'react';
import { IProductData } from 'interfaces/IProductData';
import { SubscriptionWithTax } from './SubscriptionWithTax/index';
import { SubscriptionWithTrial } from './SubscriptionWithTrial';
import { SubscriptionWithoutTaxTrial } from './SubscriptionWithoutTaxTrial/index';

interface IPriceProps {
  cart: IProductData;
}

// tslint:disable-next-line:variable-name
export const Subscription: SFC<IPriceProps> = props => {
  const { cart } = props;

  return (
    <div>
      {cart.subscription.hasTax ? <SubscriptionWithTax cart={cart} /> : null}

      {cart.subscription.hasTrial ? <SubscriptionWithTrial subscription={cart.subscription} /> : null}

      {!cart.subscription.hasTax && !cart.subscription.hasTrial ? <SubscriptionWithoutTaxTrial cart={cart} /> : null}
    </div>
  );
};
